<mat-card>
  <app-card-header
    [title]="'Test de configuración Soflex'"
    subtitle="Qué vehículos se reenviarían y qué falta para crearlos en Soflex"
    icono="fact_check"
    [botonCerrar]="true"
    (cerrar)="cerrar()"
  ></app-card-header>

  <mat-card-content class="card-content-crear">
    @if (loading) {
      <div class="centrado">
        <mat-spinner diameter="40"></mat-spinner>
        <span>Analizando la configuración…</span>
      </div>
    }

    @if (!loading && error) {
      <app-info-banner
        icon="error"
        title="No se pudo ejecutar el test"
        [message]="error"
        color="red"
        [closable]="false"
        margin="0"
      ></app-info-banner>
    }

    @if (!loading && diag) {
      <div class="secciones">
        <!-- Resultado general -->
        <app-content-card title="Resultado" icon="rule">
          <div class="bloque">
            <app-info-banner
              [icon]="diag.ok ? 'check_circle' : 'error'"
              [title]="
                diag.ok ? 'Configuración válida' : 'Configuración con problemas'
              "
              [message]="diag.mensaje"
              [color]="diag.ok ? 'green' : 'red'"
              [closable]="false"
              margin="0"
            ></app-info-banner>

            @if (diag.errores.length) {
              <div class="lista-mensajes error">
                @for (e of diag.errores; track e) {
                  <div class="mensaje">
                    <mat-icon>cancel</mat-icon>
                    <span>{{ e }}</span>
                  </div>
                }
              </div>
            }

            @if (diag.advertencias.length) {
              <div class="lista-mensajes warn">
                @for (a of diag.advertencias; track a) {
                  <div class="mensaje">
                    <mat-icon>warning</mat-icon>
                    <span>{{ a }}</span>
                  </div>
                }
              </div>
            }

            <!-- Resumen -->
            <div class="resumen">
              <div class="dato">
                <span class="valor">{{ diag.resumen.totalActivos }}</span>
                <span class="etiqueta">Vehículos alcanzados</span>
              </div>
              <div class="dato ok">
                <span class="valor">{{ diag.resumen.reenvianPosiciones }}</span>
                <span class="etiqueta">Reenvían posiciones</span>
              </div>
              <div class="dato ok">
                <span class="valor">
                  {{ diag.resumen.puedenCrearseEnSoflex }}
                </span>
                <span class="etiqueta">Se pueden crear en Soflex</span>
              </div>
              <div class="dato" [class.error]="diag.resumen.sinFleetId > 0">
                <span class="valor">{{ diag.resumen.sinFleetId }}</span>
                <span class="etiqueta">Sin flota completa</span>
              </div>
              <div class="dato" [class.warn]="diag.resumen.sinTracker > 0">
                <span class="valor">{{ diag.resumen.sinTracker }}</span>
                <span class="etiqueta">Sin tracker</span>
              </div>
              <div class="dato" [class.warn]="diag.resumen.conAdvertencias > 0">
                <span class="valor">{{ diag.resumen.conAdvertencias }}</span>
                <span class="etiqueta">Con datos faltantes</span>
              </div>
            </div>
          </div>
        </app-content-card>

        <!-- Configuración -->
        <app-content-card title="Configuración" icon="settings">
          <div class="bloque">
            <div class="grilla">
              <div>
                <span class="k">Agrupación</span>
                <span class="v">
                  @if (diag.config.agrupacionReenvio) {
                    {{ diag.config.agrupacionReenvio }}
                  } @else {
                    <span class="no-info">Sin agrupación</span>
                  }
                </span>
              </div>
              <div>
                <span class="k">Cliente de reenvío</span>
                <span class="v">
                  @if (diag.config.nombreClienteReenvio) {
                    {{ diag.config.nombreClienteReenvio }}
                  } @else {
                    <span class="no-info">Sin cliente</span>
                  }
                  @if (diag.config.reenviarHijos) {
                    <span class="chip">+ hijos</span>
                  }
                </span>
              </div>
              <div>
                <span class="k">Cliente dueño de la config</span>
                <span class="v">
                  @if (diag.config.nombreClienteDueno) {
                    {{ diag.config.nombreClienteDueno }}
                  } @else {
                    <span class="no-info">Sin cliente</span>
                  }
                  @if (diag.config.moduloSoflexActivo) {
                    <span class="chip ok">Soflex activo</span>
                  } @else {
                    <span class="chip error">Soflex inactivo</span>
                  }
                </span>
              </div>
              <div>
                <span class="k">Estado</span>
                <span class="v">
                  @if (diag.config.activo) {
                    <span class="chip ok">Activa</span>
                  } @else {
                    <span class="chip error">Inactiva</span>
                  }
                  @if (diag.config.vigente) {
                    <span class="chip ok">Vigente</span>
                  } @else {
                    <span class="chip error">Fuera de período</span>
                  }
                </span>
              </div>
              <div class="ancho">
                <span class="k">URL destino</span>
                <span class="v mono">{{ diag.config.url || 'Sin host' }}</span>
              </div>
              <div>
                <span class="k">Provider ID</span>
                <span class="v">
                  @if (diag.config.providerid) {
                    {{ diag.config.providerid }}
                  } @else {
                    <span class="no-info">Sin provider ID</span>
                  }
                </span>
              </div>
              <div>
                <span class="k">Versión</span>
                <span class="v">
                  {{ diag.config.version || 'v1.0 (default)' }}
                </span>
              </div>
              <div>
                <span class="k">Usuario</span>
                <span class="v">
                  @if (diag.config.usuario) {
                    {{ diag.config.usuario }}
                  } @else {
                    <span class="no-info">Sin usuario</span>
                  }
                </span>
              </div>
              @if (diag.config.camposFaltantes.length) {
                <div class="ancho">
                  <span class="k">Datos faltantes</span>
                  <span class="v">
                    @for (c of diag.config.camposFaltantes; track c) {
                      <span class="chip error">{{ c }}</span>
                    }
                  </span>
                </div>
              }
            </div>
          </div>
        </app-content-card>

        <!-- Clientes -->
        <app-content-card
          [title]="'Clientes alcanzados (' + diag.clientes.length + ')'"
          icon="business"
        >
          <div class="bloque">
            <div class="tabla-scroll">
              <table class="tabla">
                <thead>
                  <tr>
                    <th>Cliente</th>
                    <th>Módulo Soflex</th>
                    <th>Vehículos</th>
                  </tr>
                </thead>
                <tbody>
                  @for (c of diag.clientes; track c._id) {
                    <tr>
                      <td>{{ c.nombre || c._id }}</td>
                      <td>
                        @if (c.moduloSoflexActivo) {
                          <span class="chip ok">Activo</span>
                        } @else {
                          <span class="chip warn">Inactivo</span>
                        }
                      </td>
                      <td>{{ c.activos }}</td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
            <app-hint
              message="El módulo Soflex que habilita el reenvío es el del cliente dueño de la configuración. El fleet no se configura en el cliente: sale de la flota (grupo categoría Flota) de cada vehículo."
            ></app-hint>
          </div>
        </app-content-card>

        <!-- Flotas -->
        <app-content-card
          [title]="'Flotas (' + diag.flotas.length + ')'"
          icon="local_shipping"
        >
          <div class="bloque">
            @if (!diag.flotas.length) {
              <span class="no-info">
                Sin flotas: ningún vehículo alcanzado se sincroniza ni reenvía a
                Soflex (el fleet solo sale de la flota).
              </span>
            } @else {
              <div class="tabla-scroll">
                <table class="tabla">
                  <thead>
                    <tr>
                      <th>Flota</th>
                      <th>Cliente</th>
                      <th>fleetId</th>
                      <th>parentFleetId</th>
                      <th>fleetName</th>
                      <th>Vehículos</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (f of diag.flotas; track f._id) {
                      <tr>
                        <td>{{ f.nombre || f._id }}</td>
                        <td>
                          @if (f.nombreCliente) {
                            {{ f.nombreCliente }}
                          } @else {
                            <span class="no-info">Sin cliente</span>
                          }
                        </td>
                        <td class="mono">
                          @if (f.fleetId) {
                            {{ f.fleetId }}
                          } @else {
                            <span class="chip warn">Sin fleetId</span>
                          }
                        </td>
                        <td class="mono">
                          @if (f.parentFleetId) {
                            {{ f.parentFleetId }}
                          } @else {
                            <span class="chip warn">Sin parentFleetId</span>
                          }
                        </td>
                        <td>
                          @if (f.fleetName) {
                            {{ f.fleetName }}
                          } @else {
                            <span class="chip warn">Sin fleetName</span>
                          }
                        </td>
                        <td>{{ f.activos }}</td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            }
          </div>
        </app-content-card>

        <!-- Vehículos -->
        <app-content-card
          [title]="
            'Vehículos que se reenviarían (' +
            diag.resumen.activosMostrados +
            (diag.resumen.truncado ? ' de ' + diag.resumen.totalActivos : '') +
            ')'
          "
          icon="directions_car"
        >
          <div class="bloque">
            <div class="header-seccion">
              <div class="filtros-vehiculos">
                <mat-form-field subscriptSizing="dynamic" class="buscador">
                  <mat-label>Buscar</mat-label>
                  <input
                    matInput
                    [(ngModel)]="busqueda"
                    placeholder="Patente, tracker, flota, fleetId…"
                  />
                  <mat-icon matPrefix>search</mat-icon>
                  @if (busqueda) {
                    <button
                      irxBotonIcono
                      matSuffix
                      type="button"
                      aria-label="Limpiar búsqueda"
                      (click)="busqueda = ''"
                     tooltip="Limpiar búsqueda">
                      <mat-icon>close</mat-icon>
                    </button>
                  }
                </mat-form-field>
                <mat-checkbox
                  [(ngModel)]="soloConProblemas"
                  [disabled]="!diag.resumen.conAdvertencias"
                >
                  Solo con datos faltantes
                </mat-checkbox>
              </div>
            </div>

            @if (!activosVisibles.length) {
              <span class="no-info">
                @if (busqueda || soloConProblemas) {
                  Ningún vehículo coincide con el filtro.
                } @else {
                  No hay vehículos para mostrar.
                }
              </span>
            } @else {
              @if (busqueda || soloConProblemas) {
                <small class="ayuda">
                  Mostrando {{ activosVisibles.length }} de
                  {{ diag.resumen.activosMostrados }} vehículos.
                </small>
              }
              <div class="tabla-scroll alta">
                <table class="tabla">
                  <thead>
                    <tr>
                      <th>Vehículo</th>
                      <th>Tracker</th>
                      <th>Flota / Cliente</th>
                      <th>fleetId</th>
                      <th>Device en Soflex</th>
                      <th>Observaciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (a of activosVisibles; track a.idActivo) {
                      <tr>
                        <td>
                          <div class="celda-principal">
                            {{ a.patente || a.identificacion || a.idActivo }}
                          </div>
                          @if (a.patente && a.identificacion) {
                            <div class="celda-secundaria">
                              {{ a.identificacion }}
                            </div>
                          }
                        </td>
                        <td>
                          @if (a.idTracker) {
                            <div class="celda-principal">
                              {{ a.nombreTracker || a.idTracker }}
                            </div>
                          } @else {
                            <span class="chip warn">Sin tracker</span>
                          }
                        </td>
                        <td>
                          <div class="celda-principal">
                            @if (a.nombreGrupo) {
                              {{ a.nombreGrupo }}
                            } @else {
                              <span class="no-info">Sin grupo</span>
                            }
                          </div>
                          <div class="celda-secundaria">
                            {{ a.nombreCliente }}
                          </div>
                        </td>
                        <td>
                          @if (a.fleetId) {
                            <div class="celda-principal mono">
                              {{ a.fleetId }} / {{ a.parentFleetId }}
                            </div>
                            <div class="celda-secundaria">
                              {{ a.fleetName }}
                            </div>
                          } @else {
                            <span class="chip error">Flota incompleta</span>
                          }
                        </td>
                        <td class="mono celda-device">
                          <div>deviceid: {{ a.device.deviceid }}</div>
                          <div>plate: {{ a.device.plate }}</div>
                          <div>
                            @if (a.device.brand) {
                              {{ a.device.brand }}
                            } @else {
                              <span class="no-info">Sin marca</span>
                            }
                            /
                            @if (a.device.model) {
                              {{ a.device.model }}
                            } @else {
                              <span class="no-info">Sin modelo</span>
                            }
                            /
                            @if (a.device.year) {
                              {{ a.device.year }}
                            } @else {
                              <span class="no-info">Sin año</span>
                            }
                          </div>
                        </td>
                        <td>
                          @if (!a.advertencias.length) {
                            <span class="chip ok">OK</span>
                          } @else {
                            @for (adv of a.advertencias; track adv) {
                              <span class="chip warn">{{ adv }}</span>
                            }
                          }
                        </td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            }

            @if (diag.resumen.truncado) {
              <app-hint
                [message]="
                  'Se muestran los primeros ' +
                  diag.resumen.activosMostrados +
                  ' vehículos de ' +
                  diag.resumen.totalActivos +
                  '. Los contadores del resumen cuentan todos.'
                "
              ></app-hint>
            }
          </div>
        </app-content-card>
      </div>
    }
  </mat-card-content>

  <mat-card-actions class="actions-create">
    <button
      irxBoton="secundario"
      type="button"
      (click)="cerrar()"
      [disabled]="loading"
    >
      Cerrar
    </button>
    <button
      irxBoton="principal"
      type="button"
      (click)="probar()"
      [disabled]="loading"
    >
      <mat-icon>refresh</mat-icon>
      Volver a probar
    </button>
  </mat-card-actions>
</mat-card>
